import {combineReducers} from '@reduxjs/toolkit';
import {persistReducer, PersistConfig} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {appReducer, authReducer} from './slices';
import {adminApi} from './rtkQuery/rtkQuery';

const persistReducerProps: Pick<
  PersistConfig<any>,
  'storage' | 'writeFailHandler'
> = {
  storage,
  // writeFailHandler: (err) => logger.error('redux-persist writeFail', err),
};

const rootReducer = combineReducers({
  [adminApi.reducerPath]: adminApi.reducer,
  auth: persistReducer(
    {
      ...persistReducerProps,
      key: 'auth',
      version: 1,
      blacklist: ['idToken', 'authStateKnown'],
    },
    authReducer,
  ),
  app: appReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
